import { ActionsEnum } from "./settings";

export const modalWindowData: Record<
  ActionsEnum,
  { title: string; subtitle: string; buttonText1: string; buttonText2: string }
> = {
  [ActionsEnum.ADD]: {
    title: "",
    subtitle: "",
    buttonText1: "",
    buttonText2: "",
  },
  [ActionsEnum.EDIT]: {
    title: "",
    subtitle: "",
    buttonText1: "",
    buttonText2: "",
  },
  [ActionsEnum.DELETE]: {
    title: "Ви впевнені, що хочете продовжити видалення?",
    subtitle: "Цю дію неможливо скасувати. Дані будуть безповоротно видалені.",
    buttonText1: "Скасувати",
    buttonText2: "Підтвердити",
  },
  [ActionsEnum.EXIT]: {
    title: "Вийти з облікового запису?",
    subtitle: "Якщо ви вийдете зараз, доведеться повторно увійти, щоб продовжити роботу.",
    buttonText1: "Скасувати",
    buttonText2: "Вийти",
  },
  [ActionsEnum.CONFIRM_KANBAN_MOVING]: {
    title: "Переміщення картки",
    subtitle: "",
    buttonText1: "Скасувати",
    buttonText2: "Підтвердити",
  },
  [ActionsEnum.RESTORE]: {
    title: "Підтвердити відновлення",
    subtitle: "Відновити вибраний елемент/-и з кошика?\nВін буде повернений до відповідного розділу та стане доступним для роботи.",
    buttonText1: "Скасувати",
    buttonText2: "Продовжити",
  },
  [ActionsEnum.ARCHIVE]: {
    title: "Архівування елементу(-ів)",
    subtitle: "Дані будуть доступні для відновлення в кошику.",
    buttonText1: "Скасувати",
    buttonText2: "Продовжити",
  },
  [ActionsEnum.ON_AUTOCONTINUE]: {
    title: "Увімкнути автоматичне продовження",
    subtitle: "Після завершення поточного періоду підписка буде автоматично продовжена. Оплата спишеться з прив’язаного способу оплати у дату наступного списання. Ви зможете вимкнути автопродовження в будь-який момент до цієї дати.",
    buttonText1: "Скасувати",
    buttonText2: "Увімкнути",
  },
  [ActionsEnum.OFF_AUTOCONTINUE]: {
    title: "Вимкнути автоматичне продовження",
    subtitle: "Після завершення поточного періоду підписка не буде продовжена автоматично. Доступ до функцій тарифу збережеться до дати завершення оплаченого періоду. Після цього доступ може бути обмежено відповідно до умов тарифу.",
    buttonText1: "Скасувати",
    buttonText2: "Вимкнути",
  },
  [ActionsEnum.CANCEL_SUBSCRIPTION]: {
    title: "Скасувати підписку",
    subtitle: "Доступ до функцій тарифу збережеться до дати завершення періоду. Після цього ваш робочий простір буде переведено на безкоштовний тариф з обмеженим функціоналом. Ви можете поновити підписку у будь-який момент.",
    buttonText1: "Залишити підписку",
    buttonText2: "Скасувати підписку",
  }
};
